const getWeeksFromData = (data = []) => {
    const weeksMap = new Map();

    data.forEach((item) => {
        (item.fair_product_promotions || []).forEach((week) => {
            if (!weeksMap.has(week.week_date)) {
                weeksMap.set(week.week_date, {
                    week_date: week.week_date,
                    week_name: week.week_name,
                });
            }
        });
    });

    return Array.from(weeksMap.values()).sort((a, b) => {
        const weekA = parseInt(String(a.week_name).replace(/\D/g, ''), 10) || 0;
        const weekB = parseInt(String(b.week_name).replace(/\D/g, ''), 10) || 0;
        return weekA - weekB;
    });
};

export { getWeeksFromData };
export default getWeeksFromData;
